import { render, staticRenderFns } from "./SectionOrderWork.vue?vue&type=template&id=ea717de2&"
import script from "./SectionOrderWork.vue?vue&type=script&lang=js&"
export * from "./SectionOrderWork.vue?vue&type=script&lang=js&"
import style0 from "./SectionOrderWork.vue?vue&type=style&index=0&lang=scss&module=w&"
import style1 from "./SectionOrderWork.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["w"] = (style0.locals || style0)
this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports